/* eslint-disable no-console */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable max-len */
import React, { useState } from 'react';
import CommonSummary from '../CommonSummary';

export default function EubSummary({ OrderDetails }) {
    const [type, settype] = useState('propose');
    return (
        <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
            <div className="border-b border-[#CBCBCB] pb-2.5">
                <div className="flex justify-between items-center">
                    <div>
                        <p className="text-sm font-semibold text-[#090406] order-change" data-testid="order-type">Order Type</p>
                        <p className="sm:text-lg text-base font-normal text-[#555259]">Trade EUB Order</p>
                    </div>
                    {/* <p className="text-xs3 font-normal tedxt-[#555259]">
                        Total Order Qty.:
                        {' '}
                        <span className="font-medium">15,000 kg</span>
                    </p> */}
                </div>
                <div className="mt-3">
                    <p className="text-sm font-semibold text-[#090406]">Quantity</p>
                    <div className="items-center flex justify-between mt-2">
                        <p className="font-normal text-sm text-[#555259]">Line Items selected</p>
                        <p className="font-normal text-sm text-[#555259]">{OrderDetails.total_items}</p>
                    </div>
                    <div className="items-center flex justify-between mt-2 pb-3">
                        <p className="font-normal text-sm text-[#555259]">Net Order Quantity</p>
                        <p className="font-normal text-sm text-[#555259]">
                            {OrderDetails?.summary?.quantity && Object.keys(OrderDetails?.summary?.quantity).length > 0 && Object.keys(OrderDetails?.summary?.quantity).map((UOM, i) => (
                                <span style={{ float: `${i === 0 ? '' : 'right'}` }} key={UOM} className="font-semibold">
                                    {Number(OrderDetails?.summary?.quantity[UOM])}
                                    {' '}
                                    {UOM}
                                    {' '}
                                    <br />
                                </span>
                            ))}

                        </p>
                    </div>
                </div>
            </div>

            <div className="pt-1.5 order-summary">
                <ul className="nav nav-pills flex list-none pl-0 pb-1.5 border-b border-[#CBCBCB]" id="pills-tab" role="tablist">
                    <li onClick={() => settype('order')} className="nav-item w-1/2 text-center" role="presentation">
                        <a href="javascript:void(0)" className={`w-full nav-link block text-xs21 font-semibold text-[#808285] order-summary1 ${type === 'order' ? 'active' : ''} relative`} id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">
                            Order Summary
                        </a>
                    </li>
                    <li onClick={() => settype('propose')} className="nav-item w-1/2 text-center" role="presentation">
                        <a href="javascript:void(0)" className={`w-full nav-link block text-xs21 font-semibold text-[#808285] order-summary1 ${type === 'propose' ? 'active' : ''} relative`} id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
                            Proposed Summary
                        </a>
                    </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                    <div className={`tab-pane fade ${type === 'order' ? 'show active' : ''}`} id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                        <CommonSummary Calculation={OrderDetails.summary} orderFlow="order" GetCalculation={() => console.log('Draft')} OrderDetails={OrderDetails} />
                    </div>
                    <div className={`tab-pane fade ${type === 'propose' ? 'show active' : ''} px-1`} id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                        <CommonSummary type="propose" Calculation={OrderDetails.summary} orderFlow="order" GetCalculation={() => console.log('Draft')} OrderDetails={OrderDetails} />

                    </div>
                </div>
            </div>
        </div>
    );
}
